/* ═══════════════════════════════════════════════
   MISUNDERSTOOD — THEME.JS (Optimised)
   Single scroll handler, RAF-batched, no layout thrashing
═══════════════════════════════════════════════ */

(function() {
  'use strict';

  // ═══ SCROLL REVEAL (IntersectionObserver — no scroll listener needed) ═══
  const revealObserver = new IntersectionObserver(function(entries) {
    for (let i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('visible');
        revealObserver.unobserve(entries[i].target);
      }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  // Defer observer setup to after first paint
  requestAnimationFrame(function() {
    var els = document.querySelectorAll('.reveal, .reveal-left');
    for (var i = 0; i < els.length; i++) {
      revealObserver.observe(els[i]);
    }
  });

  // ═══ SINGLE UNIFIED SCROLL HANDLER ═══
  var scrollTicking = false;
  var popupShown = false;
  var scrollTriggered = false;
  var mainNav = null;
  var watermarks = null;
  var docHeight = 0;

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;

    requestAnimationFrame(function() {
      var scrollY = window.scrollY;

      // Nav shadow
      if (mainNav) {
        if (scrollY > 20) {
          if (!mainNav.classList.contains('scrolled')) mainNav.classList.add('scrolled');
        } else {
          mainNav.classList.remove('scrolled');
        }
      }

      // Popup auto-trigger (only compute when needed)
      if (!popupShown && !scrollTriggered) {
        if (!docHeight) docHeight = document.body.scrollHeight - window.innerHeight;
        var scrollPct = scrollY / docHeight;
        if (scrollPct > 0.6) {
          scrollTriggered = true;
          setTimeout(function() {
            if (!popupShown) { openPopup(); popupShown = true; }
          }, 8000);
        }
      }

      // Parallax — watermarks (read + write batched in same RAF)
      if (watermarks && watermarks.length) {
        for (var i = 0; i < watermarks.length; i++) {
          var el = watermarks[i];
          var section = el.closest('section');
          if (section) {
            var rect = section.getBoundingClientRect();
            var speed = parseFloat(el.dataset.parallax) || 0.3;
            el.style.transform = 'translateY(' + (-rect.top * speed) + 'px)';
          }
        }
      }

      scrollTicking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // ═══ EMAIL POPUP ═══
  window.openPopup = function() {
    var overlay = document.getElementById('popup-overlay');
    if (!overlay) return;
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Focus the email input for accessibility
    var input = document.getElementById('popup-email');
    if (input) setTimeout(function() { input.focus(); }, 400);
  };

  window.closePopup = function() {
    var overlay = document.getElementById('popup-overlay');
    if (!overlay) return;
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  // ═══ POPUP FORM SUBMISSION ═══
  window.handlePopupSubmit = function(e) {
    if (e && e.preventDefault) e.preventDefault();

    var input = document.getElementById('popup-email');
    var btn = document.getElementById('popup-btn');
    var success = document.getElementById('popup-success');
    var formWrap = document.getElementById('popup-form-wrap');
    if (!input) return;

    var email = input.value.trim();
    if (!email || email.indexOf('@') === -1) {
      input.style.borderColor = '#c0392b';
      input.focus();
      return;
    }

    input.style.borderColor = '';
    if (btn) { btn.textContent = '...'; btn.disabled = true; }

    // Shopify customer subscribe
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' +
            encodeURIComponent(email) + '&contact%5Btags%5D=newsletter'
    }).catch(function() {}).finally(function() {
      if (success) success.style.display = 'block';
      if (formWrap) formWrap.style.display = 'none';
      var disclaimer = document.querySelector('.popup__disclaimer');
      if (disclaimer) disclaimer.style.display = 'none';
      setTimeout(function() { closePopup(); }, 3000);
    });
  };

  // ═══ SHOPIFY CART API ═══
  window.addToCart = function(variantId, btn) {
    if (!variantId) return;
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = '...'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add failed');
      return fetch('/cart.js');
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var badges = document.querySelectorAll('.cart-count');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = cart.item_count;
        badges[i].classList.toggle('visible', cart.item_count > 0);
      }
      showToast('Added to bag');
    })
    .catch(function() {
      showToast('Something went wrong');
    })
    .finally(function() {
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    });
  };

  // ═══ TOAST ═══
  var toastTimer = null;
  function showToast(msg) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() { toast.classList.remove('show'); }, 3000);
  }

  // ═══ INIT ON DOM READY ═══
  document.addEventListener('DOMContentLoaded', function() {
    // Cache DOM references
    mainNav = document.getElementById('main-nav');
    watermarks = document.querySelectorAll('[data-parallax]');

    // Close popup on overlay click
    var overlay = document.getElementById('popup-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closePopup();
      });
    }

    // Escape key closes popup
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closePopup();
    });

    // Popup email — enter key
    var popupInput = document.getElementById('popup-email');
    if (popupInput) {
      popupInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') handlePopupSubmit(e);
      });
    }

    // Initialise cart count (deferred — non-blocking)
    setTimeout(function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.item_count > 0) {
            var badges = document.querySelectorAll('.cart-count');
            for (var i = 0; i < badges.length; i++) {
              badges[i].textContent = cart.item_count;
              badges[i].classList.add('visible');
            }
          }
        })
        .catch(function() {});
    }, 100);
  });

  // ═══ MOBILE MENU ═══
  window.toggleMobileMenu = function() {
    var menu = document.getElementById('mobile-menu');
    if (menu) menu.classList.toggle('open');
  };

})();
